import { render, staticRenderFns } from "./ShipList.vue?vue&type=template&id=18215640&scoped=true"
import script from "./ShipList.vue?vue&type=script&lang=js"
export * from "./ShipList.vue?vue&type=script&lang=js"
import style0 from "./ShipList.vue?vue&type=style&index=0&id=18215640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18215640",
  null
  
)

export default component.exports